const items = [
  {
    icon: 'ri-star-fill',
    value: '5.0',
    label: 'Google Rating',
    sub: 'Verified Customer Reviews',
    accent: true,
  },
  {
    icon: 'ri-shield-check-fill',
    value: '100%',
    label: 'Satisfaction Guaranteed',
    sub: 'Re-Service Free If Needed',
    accent: false,
  },
  {
    icon: 'ri-heart-fill',
    value: 'Family',
    label: 'Owned & Operated',
    sub: 'Christian Values & Ethics',
    accent: false,
  },
  {
    icon: 'ri-price-tag-3-fill',
    value: 'Free',
    label: 'Estimates',
    sub: 'No Obligation, No Pressure',
    accent: false,
  },
  {
    icon: 'ri-award-fill',
    value: 'Licensed',
    label: '& Insured',
    sub: 'Certified Technicians',
    accent: false,
  },
];

export default function TrustBar() {
  return (
    <div className="bg-stone-950 border-b border-stone-800/60">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5">
          {items.map((item, i) => (
            <div
              key={item.label}
              className={`flex flex-col items-center justify-center text-center py-7 px-4 gap-1 relative ${
                i < items.length - 1 ? 'border-r border-stone-800/60' : ''
              }`}
            >
              <div className={`w-8 h-8 flex items-center justify-center mb-1 ${item.accent ? 'text-amber-400' : 'text-amber-500/70'}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <span className={`font-extrabold text-xl leading-none ${item.accent ? 'text-amber-400' : 'text-white'}`}>
                {item.value}
              </span>
              <span className="text-white/80 text-[11px] font-semibold tracking-wide mt-0.5">{item.label}</span>
              <span className="text-stone-500 text-[10px] leading-tight">{item.sub}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
